import React from 'react';
import { PlayCircle, FileText } from 'lucide-react';
export function ResourcesSection() {
  return <section className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-193" data-mp="rjbt6gv20dq9">
      <div className="max-w-4xl mx-auto text-center bg-soft rounded-3xl p-10 md:p-16 shadow-lg border border-light/30 relative overflow-hidden" data-id="element-194" data-mp="nhyls2cbc2h8">
        {/* Decorative background elements */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-light/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-195" data-mp="il85bdwlj4va"></div>
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-warm/20 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-196" data-mp="8skb8qx03f09"></div>

        <div className="relative z-10" data-id="element-197" data-mp="3uisy87efjpu">
          <span className="inline-block px-4 py-1.5 rounded-full bg-white text-primary font-bold text-xs tracking-widest uppercase mb-6 shadow-sm" data-id="element-198" data-mp="3vxs48mq7fo0x">
            CADOUL MEU PENTRU TINE
          </span>

          <h2 className="text-3xl md:text-4xl font-serif font-bold text-dark mb-10" data-id="element-199" data-mp="3lzm161snwbuh">
            Începe de acum, gratuit
          </h2>

          {/* Resource cards with integrated buttons */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10 max-w-lg mx-auto" data-id="element-200" data-mp="1s58d4wd32ljt">
            {/* Video Card */}
            <div className="bg-white rounded-2xl p-6 shadow-md flex flex-col items-center text-center" data-id="element-201" data-mp="1eedc268tt8qs">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-primary to-medium flex items-center justify-center mb-4 shadow-lg" data-id="element-202" data-mp="1jces0iaygry1">
                <PlayCircle size={32} className="text-white" data-id="element-203" data-mp="273ah37o1191l" />
              </div>
              <h3 className="text-lg font-bold text-dark mb-2" data-id="element-204" data-mp="2b2t5weiyy49p">
                Video-uri Săptămânale Cadou
              </h3>
              <p className="text-sm text-body leading-relaxed mb-5" data-id="element-205" data-mp="1x6fk4t7ejgpf">
                Lecții video gratuite despre echilibrul trup-minte-suflet pe
                canalul meu
              </p>
              <a href="https://www.youtube.com/@drcorneliatianu/videos" className="mt-auto w-full rounded-full bg-primary text-white font-semibold px-6 py-3 hover:bg-[#5A1D5F] transition-colors shadow-md inline-block text-center text-sm" data-id="element-206" data-mp="lnv2qnhieb4x">
                Către resurse video
              </a>
            </div>

            {/* WhatsApp Card */}
            <div className="bg-white rounded-2xl p-6 shadow-md flex flex-col items-center text-center" data-id="element-207" data-mp="3txe2yjwp2zjv">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-primary to-medium flex items-center justify-center mb-4 shadow-lg" data-id="element-208" data-mp="3ozvsuq6xyeaa">
                <FileText size={32} className="text-white" data-id="element-209" data-mp="3f1gc9h5jinf1" />
              </div>
              <h3 className="text-lg font-bold text-dark mb-2" data-id="element-210" data-mp="3b0cx6wvbgvev">
                Comunitate WhatsApp
              </h3>
              <p className="text-sm text-body leading-relaxed mb-5" data-id="element-211" data-mp="361t6kj5s2vg6">
                Vino în comunitatea de WhatsApp pentru suport și conexiune
              </p>
              <a href="https://chat.whatsapp.com/CKGpQdMfE9Y5j1eimB7FlH?mode=gi_t" className="mt-auto w-full rounded-full bg-primary text-white font-semibold px-6 py-3 hover:bg-[#5A1D5F] transition-colors shadow-md inline-block text-center text-sm" data-id="element-212" data-mp="196x1vmoaasdk">
                Intră în Comunitate
              </a>
            </div>
          </div>

          <p className="text-lg text-body leading-relaxed max-w-2xl mx-auto" data-id="element-213" data-mp="1lk0u6h4kn20n">
            Primești materiale practice, exerciții simple, ghidaje și invitații
            la training-uri live, ca să începi să lucrezi cu tine chiar de azi,
            fără să cumperi nimic.
          </p>
        </div>
      </div>
    </section>;
}